// ============================================================================
// RUSSIAN TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Коллекция вдохновляющих стихов с ссылками на Стронга

export const bibleVerses = [
  {
    reference: "Филиппийцам 4:13",
    text: "Все могу в укрепляющем меня Иисусе Христе",
    version: "Синодальный перевод",
    theme: "сила",
    strongNumbers: {
      "могу": "G1411", // δύναμις (dynamis) = сила, мощь
      "укрепляющем": "G1743" // ἐνδυναμόω (endynamoo) = укреплять
    },
    context: "Павел говорит о своей способности справляться со всеми ситуациями через Христа"
  },
  {
    reference: "Псалом 23:1",
    text: "Господь - Пастырь мой; я ни в чем не буду нуждаться",
    version: "Синодальный перевод",
    theme: "защита",
    strongNumbers: {
      "Пастырь": "H7462", // רָעָה (ra'ah) = пасти, заботиться
      "нуждаться": "H2637" // חָסֵר (chaser) = нуждаться, недоставать
    },
    context: "Давид выражает свое полное доверие Божественному провидению"
  },
  {
    reference: "Иоанна 3:16",
    text: "Ибо так возлюбил Бог мир, что отдал Сына Своего Единородного",
    version: "Синодальный перевод",
    theme: "любовь",
    strongNumbers: {
      "возлюбил": "G25", // ἀγαπάω (agapao) = любить безусловно
      "отдал": "G1325" // δίδωμι (didomi) = давать, отдавать
    },
    context: "Самый известный стих о Божьей любви к человечеству"
  },
  {
    reference: "Филиппийцам 4:7",
    text: "И мир Божий, который превыше всякого ума, соблюдет сердца ваши",
    version: "Синодальный перевод",
    theme: "мир",
    strongNumbers: {
      "мир": "G1515", // εἰρήνη (eirene) = мир, гармония
      "соблюдет": "G5432" // φρουρέω (phroureo) = хранить, защищать
    },
    context: "Обещание Божественной защиты через внутренний мир"
  },
  {
    reference: "Псалом 119:105",
    text: "Слово Твое - светильник ноге моей и свет стезе моей",
    version: "Синодальный перевод",
    theme: "руководство",
    strongNumbers: {
      "светильник": "H5216", // נִיר (niyr) = светильник, светило
      "свет": "H216" // אוֹר (or) = свет, освещение
    },
    context: "Слово Божье как путеводитель в повседневной жизни"
  },
  {
    reference: "Притчи 3:5-6",
    text: "Надейся на Господа всем сердцем твоим, и не полагайся на разум твой",
    version: "Синодальный перевод",
    theme: "доверие",
    strongNumbers: {
      "Надейся": "H982", // בָּטַח (batach) = доверять
      "сердцем": "H3820" // לֵב (leb) = сердце, ум, воля
    },
    context: "Призыв доверять Богу, а не своим собственным способностям"
  },
  {
    reference: "Матфея 5:14",
    text: "Вы - свет мира. Не может укрыться город, стоящий на верху горы",
    version: "Синодальный перевод",
    theme: "свидетельство",
    strongNumbers: {
      "свет": "G5457", // φῶς (phos) = свет, духовное освещение
      "мира": "G2889" // κόσμος (kosmos) = мир, вселенная
    },
    context: "Иисус призывает своих учеников быть свидетелями в мире"
  }
];

export default bibleVerses;
